import React from "react";
import "./Service.scss";
import { Grid, useTheme, useMediaQuery } from "@mui/material";
import { ServiceProps } from "../../asset/text/service";

const Service: React.FC<ServiceProps> = ({ title, message, image }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Grid container className="container-service">
      <Grid item xs={12} sm={7} className="content-service">
        <div className="title-service">
          <h2>{title}</h2>
        </div>
        <div className="message-service">
          <p>{message}</p>
        </div>
      </Grid>
      {isMobile ? (
        <></>
      ) : title === "投資事業" ? (
        <Grid item sm={5} className="img-service-toushi">
          <img src={image} alt="" />
        </Grid>
      ) : (
        <Grid item sm={5} className="img-service">
          <img src={image} alt="" />
        </Grid>
      )}
    </Grid>
  );
};

export default Service;
